import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/globalvar';

import Layout from '@/components/template/layout/Layout';
import Login from '@/components/pages/login/Login';
import RecoveryPassword from '@/components/pages/login/RecoveryPassword';
import ForgotPassword from '@/components/pages/login/ForgotPassword';
import AccountExpired from '@/components/pages/login/AccountExpired';
import Provider from '@/components/pages/provider/SelectProvider';
import Unauthorized from '@/components/template/unauthorized/Unauthorized';
import Main from '@/components/pages/main/Main';
import PatientsList from '@/components/pages/patients/PatientsList';
import PatientSummary from '@/components/pages/patients/PatientSummary';
//import Patient from '@/components/pages/patients/Patient';
//import PatientUAE from '@/components/pages/patients/PatientUAE';
import PatientSwitcher from '@/components/pages/patients/PatientSwitcher';
import UserService from '@/services/user.service';
import GeneralNotes from '@/components/pages/patients/GeneralNotes';
import PatientAsam from '@/components/pages/patients/PatientAsam';
import ContactsList from '@/components/pages/patients/contacts/ContactsList';
import Contacts from '@/components/pages/patients/contacts/Contact';
import Insurance from '@/components/pages/patients/insurances/InsurancesList';
import InsuranceDetails from '@/components/pages/patients/insurances/Insurance';
import Clinical from '@/components/pages/clinical/Clinical';
import ClinicalDashBoard from '@/components/pages/clinical/Dashboard';
import ClinicalNotes from '@/components/pages/clinical/ClinicalNotes';
import ClinicalAsam from '@/components/pages/clinical/ClinicalAsam';
import ClinicalPatientInfo from '@/components/pages/clinical/PatientInfo';
import AccessDenied from '@/components/template/unauthorized/AccessDenied';
import AllergiesList from '@/components/pages/patients/allergies/AllergiesList';
import Allergy from '@/components/pages/patients/allergies/Allergy';
import VitalSign from '@/components/pages/clinical/vitalsign/VitalSign';
import VitalSignList from '@/components/pages/clinical/vitalsign/VitalSignList';

import MedicationsList from '@/components/pages/clinical/medications/MedicationsList';
import Medications from '@/components/pages/clinical/medications/Medications';

import Schedule from '@/components/pages/schedule/schedule_sample';
import AdmissionList from '@/components/pages/admission/AdmissionList';
import AdmissionAdd from '@/components/pages/admission/Admission';
import AdmissionClinical from '@/components/pages/admission/AdmissionClinical';
import ScheduleEditor from '@/components/pages/schedule/schedule-editor';
import ChartReviewClinical from '@/components/pages/chartreview/ClinicalChartReview';
import ChartReviewPatient from '@/components/pages/chartreview/PatientChartReview';
import Transfer from '@/components/pages/Transfer/transfer';
import Discharge from '@/components/pages/Discharge/discharge';
import PatientDischargesListing from '@/components/pages/Discharge/DischargesListing';
import Diagnosis from '@/components/pages/patients/Diagnosis';
import ClaimBatch from '@/components/pages/claimbatch/claimbatchList';
import ClaimBatchSummary from '@/components/pages/claimbatch/claimbatchSummary';
import InsuranceSetupList from '@/components/pages/setup/insuranceCompanies/insuranceSetupList.vue';
import InsuranceSetup from '@/components/pages/setup/insuranceCompanies/insuranceSetup.vue';
import DoctorSetup from '@/components/pages/setup/facilities/doctorSetup.vue';
import Doctor from '@/components/pages/setup/facilities/doctor.vue';
import ReportBuilder from '@/components/MedEZComponents/report/ReportBuilder';
import UserTemplateHeaderList from '@/components/pages/setup/users/userTemplate/userTemplateHeaderList.vue';
import UserRole from '@/components/pages/setup/users/userTemplate/userRoleDetails.vue';
import UserHeaderList from '@/components/pages/setup/users/user/userHeaderList.vue';
import UserHeader from '@/components/pages/setup/users/user/userHeader.vue';
import MethodNotAllowed from '@/components/template/notallowed/methodnotallowed';
import CreateClearingHF from '@/components/pages/claimbatch/createclearinghousefile';
import ManageClaimBatches from '@/components/pages/claimfile/manageclaimbatches';

import HcpcsCptRevCode from '@/components/pages/setup/billing/cptList';
import ModifiersList from '@/components/pages/setup/billing/modifiersList';
import PlaceofServiceList from '@/components/pages/setup/billing/placeofserviceList';
import PlaceofService from '@/components/pages/setup/billing/placeofservice';
import CPT from '@/components/pages/setup/billing/cpt';
import Modifiers from '@/components/pages/setup/billing/modifier';
import EmployeeTypeList from '@/components/pages/setup/employees/employeetypeList';
import EmployeeType from '@/components/pages/setup/employees/employeeType';
import ValueCodeList from '@/components/pages/setup/billing/valuecodeList';
import ValueCode from '@/components/pages/setup/billing/valuecode';
import RoomsList from '@/components/pages/setup/facilities/roomsList.vue';
import Rooms from '@/components/pages/setup/facilities/rooms.vue';
import BuildingList from '@/components/pages/setup/facilities/buildingList.vue';
import Building from '@/components/pages/setup/facilities/building.vue';

import EmployeeCredentialList from '@/components/pages/setup/employees/employeecredentialList';
import EmployeeCredential from '@/components/pages/setup/employees/employeecredential';

import EmployeeList from '@/components/pages/setup/employees/employeeList';
import Employee from '@/components/pages/setup/employees/employee';

import AppoinmentTypeList from '@/components/pages/setup/scheduler/appoinmentType/appoinmentTypeList';
import AppoinmentType from '@/components/pages/setup/scheduler/appoinmentType/appoinmentType';

import CalendarResourcesList from '@/components/pages/setup/scheduler/calendarResources/calendarResourcesList';
import CalendarResources from '@/components/pages/setup/scheduler/calendarResources/calendarResources';
import ReportClinicalNotes from '@/components/pages/reports/notes/rClinicalNotes';
import DocumentManagementList from '@/components/pages/patients/PatientDocumentList';
import DocumentManagement from '@/components/pages/patients/PatientDocument';

import ePharmacyPatient from '@/components/pages/ePharmacy/ePharmacyPatient';
import ePharmacyClinical from '@/components/pages/ePharmacy/ePharmacyClinical';
import DailyNotesList from '@/components/pages/clinical/dailynote/DailyNotesList';
import DailyNote from '@/components/pages/clinical/dailynote/DailyNote';
import ReportList from '@/components/pages/reports/ReportList';
import PowerBILayout from '@/components/pages/reports/powerbi/PowerBILayout';
import PowerBIReport from '@/components/pages/reports/powerbi/PowerBIReport';
import DailyServiceCharge from '@/components/pages/reports/dailyServiceCharge';
import DailyServiceLog from '@/components/pages/reports/dailyServiceLog';
import EmployeeInbox from '@/components/pages/clinical/employeeinbox/EmployeeInbox';

import GroupNotes from '@/components/pages/groupnotes/GroupNotes';
//import GroupNotesDashBoard from '@/components/pages/groupnotes/GroupNotesDashboard';
import GroupNotesAccordion from '@/components/pages/groupnotes/GroupNotesAccordion';

import LogNotesList from '@/components/pages/clinical/lognotes/LogNotesList';
import LogNote from '@/components/pages/clinical/lognotes/LogNotes';
import SchedulerDB from '@/components/pages/schedule/schedulerDB';
import AppointmentDashBoard from '@/components/pages/appointment/Dashboard';
import SchedulerNotes from '@/components/pages/appointment/SchedulerNotes';
import PatientActivitiesList from '@/components/pages/patients/activities/PatientActivitiesList';
import PatientActivity from '@/components/pages/patients/activities/EditPatientActivity';
import IncidentReport from '@/components/pages/incidentReport/IncidentReport';
import IncidentReportContent from '@/components/pages/incidentReport/IncidentReportContent';
import DrugList from '@/components/pages/setup/drugs/drugList';
import Drug from '@/components/pages/setup/drugs/drug';
import PatientContactsRep from '@/components/pages/reports/patientContactsRep';
import PatientAllergyRep from '@/components/pages/reports/PatientAllergyRep';
import PatientInsurancesRep from '@/components/pages/reports/PatientInsurancesRep';
import ICRMultipleViewRep from '@/components/pages/reports/ICRMultipleViewRep';
import SpecialPrecautionsRep from '@/components/pages/reports/SpecialPrecautionsRep';
import schedulerDailyFiltersRep from '@/components/pages/reports/schedulerDailyFiltersRep';
import ReportEmployeeCaseLoad from '@/components/pages/reports/employeeCaseLoad';
import IncidentWorkflow from '@/components/pages/incidentWorkflow/IncidentWorkflow';
import DcsList from '@/components/pages/dcs/dcsListing';
import Dcs from '@/components/pages/dcs/dcs';
import DcsPriorAuthoErrors from '@/components/pages/dcs/dcsPriorAuthoErrors';
import TPBase from '@/components/pages/treatmentplanBase/treatmentplanbase';
import WyTreatmentPlanList from '@/components/pages/wytreatmentplan/treatmentplanList';
import WyTreatmentPlan from '@/components/pages/wytreatmentplan/treatmentplan';
import MdTreatmentPlanList from '@/components/pages/mdtreatmentplan/treatmentplanList';
import MdTreatmentPlan from '@/components/pages/mdtreatmentplan/treatmentplan';
import SchedulerClinical from '@/components/pages/clinical/scheduler/SchedulerClinical';
import Appointments from '@/components/pages/patients/appointments/Appointments';
import PatientAlertList from '@/components/pages/patients/alerts/PatientAlertList';
import EditPatientAlert from '@/components/pages/patients/alerts/EditPatientAlert';

import ClinicalNotesContainer from '@/components/pages/clinicalNotesContainer/ClinicalNotesContainer';
import AppointmentEditor from '@/components/pages/appointment/AppointmentEditor';
import ScheduleDBAdmission from '@/components/pages/schedule/scheduleDB-admission';
import EditSpecialPrecautions from '@/components/pages/patients/specialPrecautions/EditSpecialPrecautions.vue';
import EditMarsAlert from '@/components/pages/nurses/mars/EditMarsAlert.vue';

import AllergySetupList from '@/components/pages/setup/allergy/allergySetupList';
import AllergySetup from '@/components/pages/setup/allergy/allergySetup';
import MarsList from '@/components/pages/nurses/mars/marsList';
import MarsPatientMed from '@/components/pages/nurses/mars/marsPatientMed';
import AdmissionsViewRep from '@/components/pages/reports/admissionsViewRep';
import patientMarsRep from '@/components/pages/reports/patientMarsRep';
import PatientAlertFiltersRep from '@/components/pages/reports/PatientAlertFiltersRep';
import PatientActivityFiltersRep from '@/components/pages/reports/PatientActivityFiltersRep';
import PatientMedicationFiltersRep from '@/components/pages/reports/PatientMedicationFiltersRep';
import PatientMarsAlertsRep from '@/components/pages/reports/PatientMarsAlertsRep';
import AuditListing from '@/components/pages/audit/AuditListing.vue';
import AuditSettingListing from '@/components/pages/audit/AuditSettingListing.vue';

import PostPayment from '@/components/pages/postPayment/PostPayment';

import DCSView from '@/components/pages/dcs/dcsview';
import DcsUpload from '@/components/pages/dcs/dcsUpload';
import ClaimBatchStatus from '../components/pages/claimbatch/claimBatchStatus.vue';

import CustomExportsList from '@/components/pages/reports/customExports/customExportsList';
import CustomExports from '@/components/pages/reports/customExports/customExports';
import CustomReports from '@/components/pages/reports/customReports/customReports';
import PatientClaim from '@/components/pages/patients/claim/PatientClaimList';
import Claim from '@/components/pages/patients/claim/Claim';
import ChargeSheet from '@/components/pages/chargeSheet/ChargeSheet';
import ChargeSheetDetail from '@/components/pages/chargeSheet/ChargeSheetDetail';
import MedicationInbox from '@/components/pages/nurses/medicationinbox/MedicationInbox';
import StandingOrders from '@/components/pages/clinical/medications/StandingOrders/StandingOrders.vue';
import DevelopmentTest from '@/components/template/test/developmenttests';

import IniUsers from '@/components/pages/initialization/iusers';
import IniUsersList from '@/components/pages/initialization/iusersList';
import IniReferralList from '@/components/pages/initialization/ireferralList';
import IniReferral from '@/components/pages/initialization/ireferral';
import IniCompany from '@/components/pages/initialization/icompanies';
//import IniProviders from '@/components/pages/initialization/iproviders'
//import IniRoles from '@/components/pages/initialization/iroles'

import IniPrograms from '@/components/pages/initialization/iprograms';
import IniNotes from '@/components/pages/initialization/inotes';
import IniTherapies from '@/components/pages/initialization/itherapies';
import IniAppTypes from '@/components/pages/initialization/iapptypes';
import IniReviewSubmit from '@/components/pages/initialization/ireviewsubmit';
import IniInsurance from '@/components/pages/initialization/iinsurance';
import PatientFaceSheetViewRep from '@/components/pages/reports/PatientFaceSheetViewRep.vue';
import PatientFaceSheetByAdmissionRep from '@/components/pages/reports/PatientFaceSheetByAdmissionRep.vue';

import DrugOrdersInbox from '@/components/pages/drugordersinbox/DrugOrdersInbox.vue';

import OrdersList from '@/components/pages/clinical/orders/OrdersList';
import Orders from '@/components/pages/clinical/orders/Orders';
import TarsList from '@/components/pages/nurses/tars/tarsList';
import DrugOrdersInboxValidation from '@/components/pages/drugordersinbox/DrugOrdersInboxValidation';
import DrugOrdersInboxFill from '@/components/pages/drugordersinbox/DrugOrdersInboxFill';
//import store from '@/globalvar.js'

import ePharmacyItemsReceivedList from '@/components/pages/ePharmacy/itemsReceived/ePharmacyItemsReceivedList';
import ePharmacyItemsReceived from '@/components/pages/ePharmacy/itemsReceived/ePharmacyItemsReceived';
import ItemExpFiltersRep from '@/components/pages/reports/ItemExpFiltersRep.vue';
import DrugIssuedByMonthRep from '@/components/pages/reports/DrugIssuedByMonthRep.vue';
import DrugOrderItemsRelocation from '@/components/pages/drugordersinbox/DrugOrderItemsRelocation';
import DrugOrderItemsRemoval from '@/components/pages/drugordersinbox/DrugOrderItemsRemoval';
import DrugOrderReturnedItems from '@/components/pages/drugordersinbox/DrugOrderReturnedItems';

import DrugInventoryItemsListing from '@/components/pages/ePharmacy/inventoryItems/DrugInventoryItemsListing';
import DrugInventoryItems from '@/components/pages/ePharmacy/inventoryItems/DrugInventoryItems';
import DrugIssueRep from '@/components/pages/reports/DrugIssueRep.vue';
import DetailPrescribedDrugsRep from '@/components/pages/reports/DetailPrescribedDrugsRep.vue';
import DrugsDisposalRep from '@/components/pages/reports/DrugsDisposalRep.vue';
import PharmacyOptions from '@/components/pages/ePharmacy/ePharmacyOptions';
import DrugsMovementRep from '@/components/pages/reports/DrugsMovementRep.vue';
import DrugsUsageByMonthRep from '@/components/pages/reports/DrugsUsageByMonthRep.vue';
import ItemAvailabilityRep from '@/components/pages/reports/ItemAvailabilityRep.vue';
import DrugsReceivedByMonthRep from '@/components/pages/reports/DrugsReceivedByMonthRep.vue';
import DetailPrescribedDrugsDiagnosisRep from '@/components/pages/reports/DetailPrescribedDrugsDiagnosisRep.vue';
import ControlledDrugsRegisterRep from '@/components/pages/reports/ControlledDrugsRegisterRep.vue';
import ItemsReceivedListFilterRep from '@/components/pages/reports/ItemsReceivedListFilterRep.vue';
import PriorAuthorizationFiltersRep from '@/components/pages/reports/PriorAuthorizationFiltersRep.vue';
import PatientLettersList from '@/components/pages/patients/letters/PatientLettersList';
import LetterManagement from '@/components/pages/patients/letters/LetterManagement';
import PreScreeningEditor from '@/components/pages/patients/preScreening/PreScreeningEditor.vue';
import ClinicalTestResultPSS from '@/components/pages/clinical/ClinicalTestResultPSS.vue';
import AdministrationFrequencyList from '@/components/pages/setup/pharmacy/administrationfrequencyList';
import AdministrationFrequency from '@/components/pages/setup/pharmacy/administrationfrequency';
import Vendorssetuplist from '@/components/pages/setup/pharmacyVendors/VendorsListing';
import DrugsProtocolSetupList from '@/components/pages/setup/pharmacy/drugsProtocols/drugsProtocolSetupList';
import DrugsProtocolSetupManagement from '@/components/pages/setup/pharmacy/drugsProtocols/drugsProtocolSetupManagement';
import PharmacyLocationsList from '@/components/pages/setup/pharmacy/locations/pharmacyLocationsList';
import PharmacyLocations from '@/components/pages/setup/pharmacy/locations/pharmacyLocations';
import BuildingPharmacyLocationSetupList from '@/components/pages/setup/pharmacy/buildingLocations/buildingPharmacyLocationSetupList';
import BuildingPharmacyLocationSetup from '@/components/pages/setup/pharmacy/buildingLocations/buildingPharmacyLocationSetup';

//import ClinicalMars from '@/components/pages/clinical/mars/ClinicalMars'
import MarsView from '@/components/pages/nurses/mars/Mars.vue';
import Vendors from '@/components/pages/setup/pharmacyVendors/Vendors';

import ItemCategoryListing from '@/components/pages/setup/itemCategory/ItemcategoryListing';
import ItemCategory from '@/components/pages/setup/itemCategory/Itemcategory';
import Restrictions from '@/components/pages/restrictions/selectRestrictions';
import testcomponent from '@/components/template/testcomponent.vue';
import LogNotesFiltersRep from '@/components/pages/reports/logNotesFiltersRep';
import UnifiedProfileList from '@/components/pages/setup/users/unifiedProfile/unifiedProfileList.vue';
import UserEmployeeDoctor from '@/components/pages/setup/users/unifiedProfile/userEmployeeDoctor.vue';
import DateRangeAttendanceList from '@/components/pages/dateRangeAttendance/dateRangeAttendanceList.vue';
import PrintLabelsRep from '@/components/pages/reports/PrintLabelsRep.vue';
import DateRangeAttendance from '@/components/pages/dateRangeAttendance/dateRangeAttendance.vue';
import EditableGridDemo from '@/components/MedEZComponents/grid/demo/EditableGridDemo.vue';
import TestOrderListing from '@/components/pages/clinical/testOrders/testOrderListing.vue';
import TestOrder from '@/components/pages/clinical/testOrders/testOrder.vue';
import TestOrderResult from '@/components/pages/clinical/testOrders/TestOrderResult.vue';
import ChargeSheetWork from '@/components/pages/chargeSheet/ChargeSheetWork.vue';
import PatientsPortalDashboard from '@/components/pages/patients/portal/patientsPortalDashboard.vue';
import PatientsPortalInfo from '@/components/pages/patients/portal/patientsPortalInfo.vue';
import PatientsPortalSetup from '@/components/pages/patients/portal/patientsPortalSetup.vue';
import PatientsPortalForm from '@/components/pages/patients/portal/patientsPortalForm.vue';
import PatientsPortalMessage from '@/components/pages/patients/portal/patientsPortalMessage.vue';
import PatientsPortalChangeInfo from '@/components/pages/patients/portal/patientsPortalChangeInfo.vue';
import PatientsPortalClaims from '@/components/pages/patients/portal/claims/patientsPortalClaims.vue';
import PatientsPortalSummary from '@/components/pages/patients/portal/patientsPortalSummary.vue';
import TestOrderLocListing from '@/components/pages/setup/lab/TestOrderLocListing';
import TestOrderLocation from '@/components/pages/setup/lab/TestOrderLocation';
import TestOrdersResultSetupListing from '@/components/pages/setup/lab/testOrdersResultSetup/TestOrdersResultSetupListing';
import TestOrdersResultSetup from '@/components/pages/setup/lab/testOrdersResultSetup/TestOrdersResultSetup';
import PatientCensusRep from '@/components/pages/reports/PatientCensusRep.vue'
import TestPanelSetupListing from '@/components/pages/setup/lab/testPanelSetup/TestPanelSetupListing';
import TestPanelSetup from '@/components/pages/setup/lab/testPanelSetup/TestPanelSetup';
import PatientsPortalContactList from '@/components/pages/patients/portal/contacts/patientsPortalContactList.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            public: true, // Have access without be authenticated
            onlyWhenLoggedOut: true // not access to login if user is authenticated
        }
    },
    {
        path: '/AccountExpired',
        name: 'AccountExpired',
        component: AccountExpired,
        meta: {
            public: true, // Have access without be authenticated
            onlyWhenLoggedOut: true // not access to login if user is authenticated
        }
    },
    {
        path: '/unauthorized',
        name: 'Unauthorized',
        component: Unauthorized,
        meta: {
            public: true, // Have access without be authenticated
            onlyWhenLoggedOut: true // not access to login if user is authenticated
        }
    },
    {
        path: '/forgotpassword',
        name: 'forgotpassword',
        component: ForgotPassword,
        meta: {
            public: true, // Have access without be authenticated
            onlyWhenLoggedOut: true // not access to login if user is authenticated
        }
    },

    {
        path: '/recoverypassword/',
        name: 'recoveryPassword',
        component: RecoveryPassword,
        props: route => ({ token: route.query.token }),
        meta: {
            public: true, // Have access without be authenticated
            onlyWhenLoggedOut: true // not access to login if user is authenticated
        }
    },

    {
        path: '/accessdenied',
        name: 'AccessDenied',
        component: AccessDenied,
        meta: {
            public: true
        }
    },
    {
        path: '/provider',
        name: 'Provider',
        component: Provider
    },
    {
        path: '/restrictions',
        name: 'Restrictions',
        component: Restrictions
    },
    {
        path: '/docs',
        name: 'docs'
    },

    {
        path: '/app',
        name: 'Layout',
        component: Layout,
        children: [
            {
                path: 'methodnotallowed',
                name: 'methodnotallowed',
                component: MethodNotAllowed
            },
            {
                path: 'drugsadministrationfrequency',
                name: 'drugsadministrationfrequency',
                component: AdministrationFrequencyList
            },
            {
                path: 'drugsadministrationfrequency/add',
                name: 'drugsadministrationfrequency-add',
                props: { editMode: false },
                component: AdministrationFrequency
            },
            {
                path: 'drugsadministrationfrequency/:id/edit',
                name: 'drugsadministrationfrequency-detail',
                props: { editMode: true },
                component: AdministrationFrequency
            },
            {
                path: 'main',
                name: 'Main',
                component: Main
            },
            {
                path: 'test',
                name: 'test',
                component: DevelopmentTest
            },
            {
                path: 'setupcompanies',
                name: 'icompany',
                component: IniCompany
            },
            {
                path: 'setupreferral',
                name: 'ireferral',
                component: IniReferralList
            },
            {
                path: 'setupreferral/add',
                name: 'ireferraladd',
                component: IniReferral,
                props: { editMode: false }
            },
            {
                path: 'setupreferral/:id/edit',
                name: 'ireferraldetail',
                component: IniReferral,
                props: { editMode: true }
            },
            /* {
        path: 'setupproviders',
        name: 'iproviders',
        component: IniProviders,
      },
      {
        path: 'setuproles',
        name: 'iroles',
        component: IniRoles,
      },  */

            {
                path: 'setupinsurance',
                name: 'iinsurance',
                component: IniInsurance
            },
            {
                path: 'setupusers',
                name: 'iusers',
                component: IniUsersList
            },
            {
                path: 'setupusers/add',
                name: 'iuseradd',
                component: IniUsers,
                props: { editMode: false }
            },
            {
                path: 'setupusers/:id/edit',
                name: 'iuserdetail',
                component: IniUsers,
                props: { editMode: true }
            },

            {
                path: 'setupprograms',
                name: 'iprograms',
                component: IniPrograms
            },
            {
                path: 'setupnotes',
                name: 'inotes',
                component: IniNotes
            },
            {
                path: 'setuptherapies',
                name: 'itherapies',
                component: IniTherapies
            },
            {
                path: 'setupapptypes',
                name: 'iapptypes',
                component: IniAppTypes
            },
            {
                path: 'setupreviewsubmit',
                name: 'ireviewsubmit',
                component: IniReviewSubmit
            },
            {
                path: 'patients',
                name: 'patients-list',
                component: PatientsList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'mars',
                name: 'mars-list',
                component: MarsList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            /*{
        path: 'clinical/:id/mars/:recordid',
        name: 'MarsClinical',
        component: ClinicalMars,
      },
      {
        path: 'clinical/:id/mars/view/:recordid',
        name: 'MarsViewClinical',
        component: MarsView,
      },*/
            {
                path: 'clinical/:id/mars/:recordid',
                name: 'MarsClinical',
                component: MarsView
            },
            {
                path: 'mars/:id',
                name: 'patient-marsMed',
                component: MarsPatientMed
                // props: route => ({ id: route.query.id})
            },
            {
                path: 'dcs',
                name: 'dcs-list',
                component: DcsList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'dcs/add',
                name: 'dcs-add',
                component: Dcs,
                props: { editMode: false },
                meta: {
                    permission: {
                        action: 'Add'
                    }
                }
            },
            {
                path: 'dcs/upload',
                name: 'dcs-upload',
                component: DcsUpload,
                props: { editMode: false },
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                //DCSView
                path:
                    'dcs/:groupId/:year/:month/:monthNumber/:version/:totalcharges/:transactions/:invoice/detail',
                name: 'dcs-detail',
                component: DCSView,
                props: { editMode: true }
            },
            {
                path: 'dcsPriorAuthoErrors',
                name: 'dcs-priorauthoerrors',
                component: DcsPriorAuthoErrors
            },
            {
                path: 'postPayment',
                name: 'postPayment',
                component: PostPayment,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'claimStatus',
                name: 'claimBatchStatus',
                component: ClaimBatchStatus,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'insurances',
                name: 'insuranceSetupList',
                component: InsuranceSetupList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patients/:id/claim',
                name: 'patientclaimList',
                component: PatientClaim
            },
            /*{
        path: "patients/:id/claim/edit/:claimId",
        name: 'claim-details',
        component: Claim,
        props: {editMode: true}
      },*/
            {
                path: 'patients/:id/claim/edit/:recId',
                name: 'claim-details',
                component: Claim,
                props: { editMode: true }
            },
            {
                path: 'patients/:id/claim/add',
                name: 'claim-add',
                component: Claim,
                props: { editMode: false }
            },
            {
                path: 'insurances/:id/edit',
                name: 'insurances-details',
                component: InsuranceSetup,
                props: { editMode: true }
            },
            {
                path: 'insurances/add',
                name: 'insurances-add',
                component: InsuranceSetup,
                props: { editMode: false }
            },
            {
                path: 'doctors',
                name: 'doctorSetup',
                component: DoctorSetup,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'doctors/:id/edit',
                name: 'doctor-details',
                component: Doctor,
                props: { editMode: true }
            },
            {
                path: 'doctors/add',
                name: 'doctor-add',
                component: Doctor,
                props: { editMode: false }
            },
            {
                path: 'claimbatch',
                name: 'claimbatch-list',
                component: ClaimBatch,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'billingclearinghousefile',
                name: 'createclearinghousefile-list',
                component: CreateClearingHF,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'claimbatch/summary/:id',
                name: 'claimbatch-summary',
                component: ClaimBatchSummary,
                props: { editMode: true }
            },
            {
                path: 'manageclaimbatches',
                name: 'manageclaimbatches-list',
                component: ManageClaimBatches,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'cpt',
                name: 'hcpcscpt',
                component: HcpcsCptRevCode,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'modifiers',
                name: 'modifier-list',
                component: ModifiersList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'placeofservices',
                name: 'placeofservice-List',
                component: PlaceofServiceList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patients/:id/patientinfo',
                name: 'patient-details',
                // component: store.state.companies.isUAE ? PatientUAE : Patient,
                component: PatientSwitcher,
                /* component: async () => {
          const isUAE = await store.state.companies.isUAE;
          return isUAE ? PatientUAE : Patient;
        },*/
                props: { editMode: true }
            },
            /*{
        path: "patients/:id/patientinfo",
        name: 'patient-detailsUAE',
        component: PatientUAE,
        props: {editMode: true}
      },   */

            {
                path: 'patients/summary/:id',
                name: 'patient-summary',
                component: PatientSummary,
                props: { editMode: true }
            },
            {
                path: 'patients/add',
                name: 'patient-add',
                component: PatientSwitcher,
                /*component: async () => {
          const isUAE = await store.state.companies.isUAE;
          return isUAE ? PatientUAE : Patient;
        },*/
                props: { editMode: false }
            },
            /* {
        path: 'patients/add',
        name: 'patient-addUAE',
        component: PatientUAE,
        props: {editMode: false}
      },*/
            {
                path: 'patients/:id/generalnotes',
                name: 'patient-generalnotes',
                component: GeneralNotes,
                props: { editMode: true }
            },
            {
                path: 'patients/:id/asam',
                name: 'patient-asam',
                component: PatientAsam,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseASAM'
                    }
                }
            },
            {
                path: 'patients/:id/contacts',
                name: 'patient-contacts',
                component: ContactsList,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'patients/:id/diagnosis',
                name: 'patient-diagnosis',
                component: Diagnosis,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDiagnosis'
                    }
                }
            },
            {
                path: 'appointments/:id/diagnosis/:actId',
                name: 'appointmentDB-diagnosis',
                component: Diagnosis,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDiagnosis'
                    }
                }
            },
            {
                path: 'clinical/:id/diagnosis/:recordid',
                name: 'Clinical-diagnosis',
                component: Diagnosis,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDiagnosis'
                    }
                }
            },
            {
                path: 'clinical/:id/insurances/:recordid',
                name: 'Clinical-insurance',
                component: Insurance,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInsurance'
                    }
                }
            },
            {
                path: 'clinical/insurance-details/:id/:recordid/:idInsurance',
                name: 'Clinical-insurance-details',
                component: InsuranceDetails,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInsurance'
                    }
                }
            },
            {
                path: 'clinical/add-insurance/:id/:recordid',
                name: 'add-Clinical-insurance',
                component: InsuranceDetails,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInsurance'
                    }
                }
            },
            {
                path: 'clinical/:id/allergies/:recordid',
                name: 'Clinical-allergies',
                component: AllergiesList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },

            {
                path: 'clinical/:id/allergies/:allergyid/:recordid',
                name: 'Clinical-allergies-details',
                component: Allergy,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },
            {
                path: 'clinical/:id/allergies/:recordid',
                name: 'Clinical-allergies-Add-details',
                component: Allergy,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },
            /*{
        path: 'clinical/add-insurance/:id/:recordid',
        name: 'add-Clinical-insurance',
        component: InsuranceDetails,
        props: {editMode: false}
      },*/
            {
                path: 'clinical/:id/contacts/:recordid',
                name: 'Clinical-cont',
                component: ContactsList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'clinical/:id/contacts/:contactid/:recordid',
                name: 'Clinical-cont-details',
                component: Contacts,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'clinical/:id/contact-add/:recordid',
                name: 'Clinical-cont-add',
                component: Contacts,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'clinical/:id/document/:recordid',
                name: 'Clinical-document',
                component: DocumentManagementList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDocument'
                    }
                }
            },
            {
                path: 'clinical/:id/document/:seqNo/:recordid',
                name: 'Clinical-document-detail',
                component: DocumentManagement,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDocument'
                    }
                }
            },
            {
                path: 'clinical/:id/document-add/:recordid',
                name: 'Clinical-document-add',
                component: DocumentManagement,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDocument'
                    }
                }
            },
            {
                path: 'patients/:id/admission',
                name: 'patient-admissionList',
                component: AdmissionList,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAdmission'
                    }
                }
            },
            {
                path: 'patients/:id/admission/add',
                name: 'patient-admission-add',
                component: AdmissionAdd,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAdmission'
                    }
                }
            },
            {
                path: 'patients/:id/admission/:recordid',
                name: 'patient-admission-edit',
                component: AdmissionAdd,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAdmission'
                    }
                }
            },
            {
                path: 'appointments/:id/admission/:actId',
                name: 'appointmentDB-admissionList',
                component: AdmissionList,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAdmission'
                    }
                }
            },
            {
                path: 'appointments/:id/admission/add/:actId',
                name: 'appointmentDB-admission-add',
                component: AdmissionAdd,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAdmission'
                    }
                }
            },
            {
                path: 'appointments/:id/admission/:recordid/:actId',
                name: 'appointmentDB-admission-edit',
                component: AdmissionAdd,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAdmission'
                    }
                }
            },
            {
                path: 'appointments/:id/allergies/:actId',
                name: 'appointmentDB-allergies',
                component: AllergiesList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },
            {
                path: 'appointments/:id/insurances/:actId',
                name: 'appointments-insurance',
                component: Insurance,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInsurance'
                    }
                }
            },
            {
                path: 'appointments/:id/allergies/:allergyid/:actId',
                name: 'appointmentDB-allergies-details',
                component: Allergy,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },
            {
                path: 'appointments/:id/allergy-add/:actId',
                name: 'appointmentDB-allergies-add',
                component: Allergy,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },
            {
                path: 'clinical/:id/admission/:recordid',
                name: 'admission-clinical',
                component: AdmissionClinical,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAdmission'
                    }
                }
            },
            {
                path: 'patients/:id/contacts/:contactid',
                name: 'contact-details',
                component: Contacts,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'patients/:id/contact-add',
                name: 'patient-contact-add',
                component: Contacts,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'appointments/:id/contacts/:actId',
                name: 'appointmentDB-Ctacts',
                component: ContactsList,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'appointments/:id/contacts/:contactid/:actId',
                name: 'appointmentDB-Ctacts-details',
                component: Contacts,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'appointments/:id/contact-add/:actId',
                name: 'appointmentDB-Ctacts-add',
                component: Contacts,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'patients/:id/insurances',
                name: 'patient-insurance',
                component: Insurance,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInsurance'
                    }
                }
            },
            {
                path: 'patients/:id/document',
                name: 'patient-document',
                component: DocumentManagementList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDocument'
                    }
                }
            },
            {
                path: 'patients/:id/document/:seqNo',
                name: 'patient-document-detail',
                component: DocumentManagement,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDocument'
                    }
                }
            },
            {
                path: 'patients/:id/document-add',
                name: 'patient-document-add',
                component: DocumentManagement,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDocument'
                    }
                }
            },
            {
                path: 'appointments/:id/document/:actId',
                name: 'appointments-document',
                component: DocumentManagementList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDocument'
                    }
                }
            },
            {
                path: 'appointments/:id/document/:seqNo/:actId',
                name: 'appointmentDB-document-detail',
                component: DocumentManagement,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDocument'
                    }
                }
            },
            {
                path: 'appointments/:id/document-add/:actId',
                name: 'appointmentDB-document-add',
                component: DocumentManagement,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientDocument'
                    }
                }
            },
            {
                path: 'patients/insurance-details/:id/:idInsurance',
                name: 'patient-insurance-details',
                component: InsuranceDetails,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInsurance'
                    }
                }
            },
            {
                path: 'patients/add-insurance/:id',
                name: 'add-patient-insurance',
                component: InsuranceDetails,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInsurance'
                    }
                }
            },
            {
                path: 'appointments/:id/insurances/:actId',
                name: 'appointmentDB-Insurance',
                component: Insurance,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInsurance'
                    }
                }
            },
            {
                path: 'appointments/insurance-details/:id/:idInsurance/:actId',
                name: 'appointments-insurance-details',
                component: InsuranceDetails,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInsurance'
                    }
                }
            },
            {
                path: 'appointments/add-insurance/:id/:actId',
                name: 'add-appointments-insurance',
                component: InsuranceDetails,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInsurance'
                    }
                }
            },
            {
                path: 'clinical',
                name: 'Clinical',
                component: Clinical,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'clinicalnotes',
                name: 'clinicalNotesContainer',
                component: ClinicalNotesContainer,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'clinical/:id/dashboard/:recordid',
                name: 'Clinical-Dashboard',
                component: ClinicalDashBoard
            },
            {
                path: 'appointments/:id/dashboard/:actId',
                name: 'appointmentDB-Dashboard',
                component: AppointmentDashBoard
            },
            {
                path: 'clinical/:id/patientinfo/:recordid',
                name: 'Clinical-PatientInfo',
                component: ClinicalPatientInfo,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientInfo'
                    }
                }
            },
            {
                path: 'clinical/:id/notes/:recordid',
                name: 'Clinical-Notes',
                component: ClinicalNotes,
                meta: {
                    permission: {
                        ehrFeature: 'isUseClinicalNotes'
                    }
                }
            },
            {
                path: 'clinical/:id/chartreview/:recordid',
                name: 'Clinicalchartreview',
                component: ChartReviewClinical,
                meta: {
                    permission: {
                        ehrFeature: 'isUseChartReview'
                    }
                }
            },
            {
                path: 'patients/:id/chartreview',
                name: 'patientchartreview',
                component: ChartReviewPatient,
                meta: {
                    permission: {
                        ehrFeature: 'isUseChartReview'
                    }
                }
            },
            {
                path: 'appointments/:id/chartreview/:actId',
                name: 'appointmentDB-chartreview',
                component: ChartReviewPatient,
                meta: {
                    permission: {
                        ehrFeature: 'isUseChartReview'
                    }
                }
            },
            {
                path: 'patients/:id/ePharmacy',
                name: 'patientePharmacy',
                component: ePharmacyPatient,
                meta: {
                    permission: {
                        ehrFeature: 'isUsepharmacyPatientNewCrop'
                    }
                }
            },
            {
                path: 'clinical/:id/ePharmacy/:recordid',
                name: 'clinicalePharmacy',
                component: ePharmacyClinical,
                meta: {
                    permission: {
                        ehrFeature: 'isUsepharmacyPatientNewCrop'
                    }
                }
            },
            {
                path: 'clinical/:id/asam/:recordid',
                name: 'Clinical-Asam',
                component: ClinicalAsam,
                meta: {
                    permission: {
                        ehrFeature: 'isUseASAM'
                    }
                }
            },
            {
                path: 'patients/:id/allergies',
                name: 'patient-allergies',
                component: AllergiesList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },
            {
                path: 'patients/:id/allergies/:allergyid',
                name: 'allergy-details',
                component: Allergy,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },
            {
                path: 'clinical/:id/allergies/:recordid',
                name: 'Clinical-PatientAllergies',
                component: AllergiesList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },
            {
                path: 'clinical/:id/transfer/:recordid',
                name: 'Clinical-Transfer',
                component: Transfer,
                meta: {
                    permission: {
                        ehrFeature: 'isUseTransfer'
                    }
                }
            },
            // Wiley Treatment Plan
            {
                path: 'clinical/:id/wytreatmentplan/:recordid/:notesid',
                name: 'WyTreatmentplan-Clinical',
                component: WyTreatmentPlanList,
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'appointments/:id/wytreatmentplan/:recordid/:notesid',
                name: 'WyTreatmentplan-Appointment',
                component: WyTreatmentPlanList,
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'clinical/:id/wytreatmentplan/:recordid/:problemid',
                name: 'WyTreatmentplan-details-Clinical',
                component: WyTreatmentPlan,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'clinical/:id/wytreatmentplan/:recordid/add/:notesid',
                name: 'WyTreatmentplan-add-Clinical',
                component: WyTreatmentPlan,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'appointments/:id/wytreatmentplan/:recordid/add/:notesid',
                name: 'WyTreatmentplan-add-Appointment',
                component: WyTreatmentPlan,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            // MedEZ Treatment Plan
            {
                path: 'clinical/:id/mdtreatmentplan/:recordid/:notesid',
                name: 'MdTreatmentplan-Clinical',
                component: MdTreatmentPlanList,
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'appointments/:id/mdtreatmentplan/:recordid/:notesid',
                name: 'appointmentDB-MdTreatmentplan',
                component: MdTreatmentPlanList,
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'clinical/:id/mdtreatmentplan/:recordid/:problemid',
                name: 'MdTreatmentplan-details-Clinical',
                component: MdTreatmentPlan,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'clinical/:id/mdtreatmentplan/:recordid/add/:notesid',
                name: 'MdTreatmentplan-add-Clinical',
                component: MdTreatmentPlan,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'appointments/:id/mdtreatmentplan/:recordid/add/:notesid',
                name: 'MdTreatmentplan-add-Appointment',
                component: MdTreatmentPlan,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'clinical/:id/treatmentplan/:recordid',
                name: 'treatmentplanbase-Clinical',
                component: TPBase,
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'appointments/:id/treatmentplan/:actId',
                name: 'treatmentplanbase-Scheduler',
                component: TPBase,
                meta: {
                    permission: {
                        ehrFeature: 'isUseTreatmentPlanClinical'
                    }
                }
            },
            {
                path: 'clinical/:id/discharge/:recordid',
                name: 'Clinical-Discharge',
                component: Discharge,
                meta: {
                    permission: {
                        ehrFeature: 'isUseDischarge'
                    }
                }
            },
            {
                path: 'clinical/:id/allergy-add/:recordid',
                name: 'Clinical-allergies-add',
                component: Allergy,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },
            {
                path: 'patients/:id/allergy-add',
                name: 'patient-allergy-add',
                component: Allergy,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAllergies'
                    }
                }
            },
            {
                path: 'clinical/:id/vital/:recordid',
                name: 'Clinical-vital-sign',
                component: VitalSignList,
                meta: {
                    permission: {
                        ehrFeature: 'isUseVitalSign'
                    }
                }
            },
            {
                path: 'clinical/:id/vs-add/:recordid',
                name: 'vs-add',
                component: VitalSign,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUseVitalSign'
                    }
                }
            },
            {
                path: 'clinical/:id/vital/:recordid/:vsid',
                name: 'vs-details',
                component: VitalSign,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseVitalSign'
                    }
                }
            },
            {
                path: 'appointments/:id/vital/:actId',
                name: 'appointmentDB-vital-sign',
                component: VitalSignList
            },
            {
                path: 'appointments/:id/vs-add/:actId',
                name: 'appointmentDB-vital-add',
                component: VitalSign,
                props: { editMode: false }
            },
            {
                path: 'appointments/:id/vital/:vsid/:actId',
                name: 'appointmentDB-vital-details',
                component: VitalSign,
                props: { editMode: true }
            },
            {
                path: 'clinical/:id/medications/:recordid',
                name: 'Clinical-Medications',
                component: MedicationsList,
                meta: {
                    permission: {
                        ehrFeature: 'isUseMedications'
                    }
                }
            },
            {
                path: 'clinical/:id/addmedications/:recordid',
                name: 'Clinical-medications-add',
                component: Medications,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUseMedications'
                    }
                }
            },
            {
                path: 'clinical/:id/medications/:recordid/code/:recId',
                name: 'Clinical-medications-details',
                component: Medications,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseMedications'
                    }
                }
            },
            {
                path: 'clinical/:id/standing-orders/:recordid',
                name: 'Clinical-medications-standing-orders',
                component: StandingOrders,
                meta: {
                    permission: {
                        ehrFeature: 'isUseMedications'
                    }
                }
            },
            {
                path: 'appointments/:id/medications/:actId',
                name: 'appointmentDB-Medications',
                component: MedicationsList,
                meta: {
                    permission: {
                        ehrFeature: 'isUseMedications'
                    }
                }
            },
            {
                path: 'appointments/:id/addmedications/:actId',
                name: 'Appointments-medications-add',
                component: Medications,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUseMedications'
                    }
                }
            },
            {
                path: 'appointments/:id/medications/code/:recId/:actId',
                name: 'Appointments-medications-details',
                component: Medications,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseMedications'
                    }
                }
            },
            {
                path: 'appointments/:id/standing-orders/:actId',
                name: 'Appointments-medications-standing-orders',
                component: StandingOrders
            },

            {
                path: 'clinical/:id/dailynote/:recordid',
                name: 'Clinical-daily-note',
                component: DailyNotesList,
                meta: {
                    permission: {
                        ehrFeature: 'isUseDailyNotes'
                    }
                }
            },
            {
                path:
                    'clinical/:id/dailynote/:recordid/:dailynoteid/:noteTypeName/:noteEmployeeCode',
                name: 'dailynote-details',
                component: DailyNote,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseDailyNotes'
                    }
                }
            },
            {
                path: 'clinical/:id/dailynote-add/:recordid/:notetype/:noteTypeName',
                name: 'dailynote-add',
                component: DailyNote,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUseDailyNotes'
                    }
                }
            },
            {
                path: 'clinical/:id/lognote/:recordid',
                name: 'Clinical-log-note',
                component: LogNotesList,
                meta: {
                    permission: {
                        ehrFeature: 'isUseLogNotes'
                    }
                }
            },
            {
                path: 'clinical/:id/lognote/:recordid/:lognoteid/:intakedate/:noteTypeName',
                name: 'lognote-details',
                component: LogNote,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseLogNotes'
                    }
                }
            },
            {
                path: 'clinical/:id/lognote-add/:recordid/:lognoteid/:noteTypeName',
                name: 'lognote-add',
                component: LogNote,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUseLogNotes'
                    }
                }
            },
            {
                path: 'employeeinbox',
                name: 'Clinical-employee-inbox',
                component: EmployeeInbox,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'scheduler',
                name: 'scheduler',
                component: Schedule,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'schedule-editor',
                name: 'schedule-editor',
                component: ScheduleEditor
            },
            {
                path: 'reportbuilder',
                name: 'reportbuilder',
                component: ReportBuilder,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'roles',
                name: 'roles',
                component: UserTemplateHeaderList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'roles/:id/edit',
                name: 'role-details',
                component: UserRole,
                props: { editMode: true, clone: false }
            },
            {
                path: 'roles/add',
                name: 'role-add',
                component: UserRole,
                props: { editMode: false }
            },
            {
                path: 'roles/:id/clone',
                name: 'role-clone',
                component: UserRole,
                props: { editMode: false, clone: true }
            },
            {
                path: 'users',
                name: 'users',
                component: UserHeaderList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'users/:id/edit',
                name: 'users-details',
                component: UserHeader,
                props: { editMode: true }
            },
            {
                path: 'users/add',
                name: 'users-add',
                component: UserHeader,
                props: { editMode: false }
            },
            {
                path: 'cpt/:id/edit',
                name: 'cpt-details',
                component: CPT,
                props: { editMode: true }
            },
            {
                path: 'cpt/add',
                name: 'cpt-add',
                component: CPT,
                props: { editMode: false }
            },
            {
                path: 'modifiers/:id/edit',
                name: 'modifiers-details',
                component: Modifiers,
                props: { editMode: true }
            },
            {
                path: 'modifiers/add',
                name: 'modifiers-add',
                component: Modifiers,
                props: { editMode: false }
            },
            {
                path: 'placeofservices/:id/edit',
                name: 'placeofservices-details',
                component: PlaceofService,
                props: { editMode: true }
            },
            {
                path: 'placeofservices/add',
                name: 'placeofservices-add',
                component: PlaceofService,
                props: { editMode: false }
            },
            {
                path: 'employeetypes',
                name: 'employeeTypeList',
                component: EmployeeTypeList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'employeetypes/:id/edit',
                name: 'employeeType-details',
                component: EmployeeType,
                props: { editMode: true }
            },
            {
                path: 'employeetypes/add',
                name: 'employeeType-add',
                component: EmployeeType,
                props: { editMode: false }
            },
            {
                path: 'valuecodes',
                name: 'valuecodesList',
                component: ValueCodeList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'valuecodes/:id/edit',
                name: 'valuecode-details',
                component: ValueCode,
                props: { editMode: true }
            },
            {
                path: 'valuecodes/add',
                name: 'valuecode-add',
                component: ValueCode,
                props: { editMode: false }
            },
            {
                path: 'rooms',
                name: 'roomsList',
                component: RoomsList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'rooms/:id/edit',
                name: 'rooms-details',
                component: Rooms,
                props: { editMode: true }
            },
            {
                path: 'rooms/add',
                name: 'rooms-add',
                component: Rooms,
                props: { editMode: false }
            },
            {
                path: 'buildings',
                name: 'buildingsList',
                component: BuildingList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'buildings/:id/edit',
                name: 'buildings-details',
                component: Building,
                props: { editMode: true }
            },
            {
                path: 'buildings/add',
                name: 'buildings-add',
                component: Building,
                props: { editMode: false }
            },

            {
                path: 'employeecredentials',
                name: 'employeecredentialsList',
                component: EmployeeCredentialList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'employeecredentials/:id/edit',
                name: 'employeecredentials-details',
                component: EmployeeCredential,
                props: { editMode: true }
            },
            {
                path: 'employeecredentials/add',
                name: 'employeecredentials-add',
                component: EmployeeCredential,
                props: { editMode: false }
            },

            {
                path: 'employees',
                name: 'employeeList',
                component: EmployeeList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'employees/:id/edit',
                name: 'employee-details',
                component: Employee,
                props: { editMode: true }
            },
            {
                path: 'employees/add',
                name: 'employee-add',
                component: Employee,
                props: { editMode: false }
            },

            {
                path: 'appointmenttypes',
                name: 'appointmenttypesList',
                component: AppoinmentTypeList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'appointmenttypes/:id/edit',
                name: 'appointmenttypes-details',
                component: AppoinmentType,
                props: { editMode: true }
            },
            {
                path: 'appointmenttypes/add',
                name: 'appointmenttypes-add',
                component: AppoinmentType,
                props: { editMode: false }
            },
            {
                path: 'calendarresources',
                name: 'calendarresourcesList',
                component: CalendarResourcesList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'appointments',
                name: 'appointments',
                component: SchedulerDB,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'calendarresources/:id/edit',
                name: 'calendarresources-details',
                component: CalendarResources,
                props: { editMode: true }
            },
            {
                path: 'calendarresources/add',
                name: 'calendarresources-add',
                component: CalendarResources,
                props: { editMode: false }
            },
            {
                path: 'clinicalnotesreport',
                name: 'reportClinicalNotes',
                component: ReportClinicalNotes
            },
            {
                path: 'lognotesreport',
                name: 'logNotesFiltersRep',
                component: LogNotesFiltersRep
            },
            {
                path: 'printlabelsreport',
                name: 'printlabelsreport',
                component: PrintLabelsRep
            },
            {
                path: 'reports/favorites',
                name: 'reportList',
                component: ReportList,
                props: { mode: 'favorites' },
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'reports/notes',
                name: 'reportListNotes',
                component: ReportList,
                props: { category: 'Notes' },
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'reports/billing',
                name: 'reportListBilling',
                component: ReportList,
                props: { category: 'Billing' },
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'reports/patients',
                name: 'reportListPatient',
                component: ReportList,
                props: { category: 'Patients' }
            },
            {
                path: 'reports/powerbi',
                name: 'reportListPowerBI',
                component: PowerBILayout,
                props: { category: 'Power BI' },
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'reports/:type/:id/powerbi/:name',
                name: 'PowerBI-Report',
                component: PowerBIReport
            },
            {
                path: 'dailyservicechargesreport',
                name: 'DailyServiceCharge',
                component: DailyServiceCharge
            },
            {
                path: 'dailyservicelogreport',
                name: 'DailyServiceLog',
                component: DailyServiceLog
            },
            {
                path: 'reports/pharmacy',
                name: 'reportListPharmacy',
                component: ReportList,
                props: { category: 'Pharmacy' },
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'itemsexpirationreport',
                name: 'ItemExpFiltersRep',
                component: ItemExpFiltersRep
            },
            {
                path: 'drugissuedbymonth',
                name: 'DrugIssuedByMonthRep',
                component: DrugIssuedByMonthRep
            },
            {
                path: 'drugsissue',
                name: 'DrugIssueRep',
                component: DrugIssueRep
            },
            {
                path: 'detailprescribeddrugs',
                name: 'DetailPrescribedDrugsRep',
                component: DetailPrescribedDrugsRep
            },
            {
                path: 'drugsdisposal',
                name: 'DrugsDisposalRep',
                component: DrugsDisposalRep
            },
            {
                path: 'drugsmovement',
                name: 'DrugsMovementRep',
                component: DrugsMovementRep
            },
            {
                path: 'drugsusagebymonth',
                name: 'DrugsUsageByMonthRep',
                component: DrugsUsageByMonthRep
            },
            {
                path: 'itemsavailability',
                name: 'ItemAvailabilityRep',
                component: ItemAvailabilityRep
            },
            {
                path: 'drugsreceivedbymonth',
                name: 'DrugsReceivedByMonthRep',
                component: DrugsReceivedByMonthRep
            },
            {
                path: 'detailprescribeddrugsd',
                name: 'DetailPrescribedDrugsDiagnosisRep',
                component: DetailPrescribedDrugsDiagnosisRep
            },
            {
                path: 'controlleddrugregister',
                name: 'ControlledDrugsRegisterRep',
                component: ControlledDrugsRegisterRep
            },
            {
                path: 'itemreceive',
                name: 'ItemsReceivedListFilterRep',
                component: ItemsReceivedListFilterRep
            },
            {
                path: 'dcspriorauthreport',
                name: 'PriorAuthorizationFiltersRep',
                component: PriorAuthorizationFiltersRep
            },
            {
                path: 'groupnotes',
                name: 'groupnotes',
                component: GroupNotes,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'groupnotes/:id',
                name: 'groupnotes-Dashboard',
                component: GroupNotesAccordion
            },
            {
                path: 'appointments/:id/schedulernotes/:actId',
                name: 'appointmentDB-notes',
                component: SchedulerNotes
            },
            {
                path: 'appointments-patientdb/:id/schedulernotes/:actId',
                name: 'appointment-patientdb-notes',
                component: SchedulerNotes,
                props: { patientDB: true }
            },
            {
                path: 'incidents',
                name: 'incident-report',
                props: { keepFilter: false },
                component: IncidentReport,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'incidents',
                name: 'incident-report-back',
                props: { keepFilter: true },
                component: IncidentReport,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'incident-detail/:IncidentID',
                name: 'incident-content',
                props: { editMode: true },
                component: IncidentReportContent
            },
            {
                path: 'incident-detail',
                name: 'incident-report-general-info-add',
                props: { editMode: false },
                component: IncidentReportContent
            },
            {
                path: 'druglist',
                name: 'DrugList',
                component: DrugList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'drug',
                name: 'Drug',
                component: Drug
            },
            {
                path: 'drugs/:id/edit',
                name: 'drug-details',
                component: Drug,
                props: { editMode: true }
            },
            {
                path: 'drugs/add',
                name: 'drug-add',
                component: Drug,
                props: { editMode: false }
            },
            {
                path: 'patientcontactsreport',
                name: 'PatientContactsRep',
                component: PatientContactsRep,
                props: { filterView: true, recNo: null, patientCode: null }
            },
            {
                path: 'patientallergiesreport',
                name: 'PatientAllergyRep',
                component: PatientAllergyRep,
                props: { filterView: true, recNo: null, patientCode: null }
            },
            {
                path: 'patientinsurancesreport',
                name: 'PatientInsurancesRep',
                component: PatientInsurancesRep,
                props: { showModal: true, RecNo: null, PatientCode: null }
            },
            {
                path: 'specialprecautionsreport',
                name: 'SpecialPrecautionsRep',
                component: SpecialPrecautionsRep,
                props: { showModal: true, PatientCode: null }
            },
            {
                path: 'icrmultiplerep',
                name: 'ICRMultipleViewRep',
                component: ICRMultipleViewRep
            },
            {
                path: 'employeecaseloadreport',
                name: 'reportEmployeeCaseLoad',
                component: ReportEmployeeCaseLoad
            },
            {
                path: 'schedulerdailyfiltersrep',
                name: 'schedulerDailyFiltersRep',
                component: schedulerDailyFiltersRep
            },
            {
                path: 'patientalertsreport',
                name: 'PatientAlertFiltersRep',
                component: PatientAlertFiltersRep
            },
            {
                path: 'patientactreport',
                name: 'PatientActivityFiltersRep',
                component: PatientActivityFiltersRep
            },
            {
                path: 'patientmedreport',
                name: 'PatientMedicationFiltersRep',
                component: PatientMedicationFiltersRep
            },
            {
                path: 'marsalertsreport',
                name: 'PatientMarsAlertsRep',
                component: PatientMarsAlertsRep,
                props: { showModal: true, PatientCode: null }
            },
            {
                path: 'reports/employeecaseload',
                name: 'reportListEmployeeCaseLoad',
                component: ReportList,
                props: { category: 'EmployeeCaseLoad' }
            },
            {
                path: 'incidentsworkflow',
                name: 'IncidentWorkflow',
                component: IncidentWorkflow,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'clinical/:id/scheduler/:recordid',
                name: 'SchedulerClinical',
                component: SchedulerClinical,
                meta: {
                    permission: {
                        ehrFeature: 'isUseSchedulerClinical'
                    }
                }
            },
            {
                path: 'patient/:id/scheduler/',
                name: 'SchedulerPatient',
                component: SchedulerClinical,
                props: { patientDB: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseSchedulerClinical'
                    }
                }
            },
            {
                path: 'patients/:id/appointments',
                name: 'patient-appoint',
                component: Appointments,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isAppointments'
                    }
                }
            },
            {
                path: 'clinical/:id/appointments/:recordid',
                name: 'clinical-appoint',
                component: Appointments,
                props: { clinical: true },
                meta: {
                    permission: {
                        ehrFeature: 'isAppointments'
                    }
                }
            },
            {
                path: 'appointments/:id/patientinfo/:actId',
                name: 'appointmentDB-PatientInfo',
                component: ClinicalPatientInfo,
                props: { editMode: true }
            },
            {
                path: 'appointments/:id/editor/:actId',
                name: 'appointmentDB-Editor',
                component: AppointmentEditor,
                props: { editMode: true }
            },
            {
                path: 'appointments/editor/add',
                name: 'appointmentDB-Editor-Add',
                component: AppointmentEditor,
                props: { editMode: false }
            },
            {
                path: 'appointments/:id/asam/:actId',
                name: 'appointmentDB-asam',
                component: PatientAsam,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseASAM'
                    }
                }
            },
            {
                path: 'appointments/:id/discharge/:actId',
                name: 'appointmentDB-discharge',
                component: ScheduleDBAdmission
            },
            {
                path: 'appointments/:id/discharge/:actId/:recordid',
                name: 'appointments-discharge',
                component: Discharge,
                meta: {
                    permission: {
                        ehrFeature: 'isUseDischarge'
                    }
                }
            },
            {
                path: 'appointments/:id/transfer/:actId',
                name: 'appointmentDB-transfer',
                component: ScheduleDBAdmission,
                meta: {
                    permission: {
                        ehrFeature: 'isUseTransfer'
                    }
                }
            },
            {
                path: 'appointments/:id/transfer/:actId/:recordid',
                name: 'appointments-transfer',
                component: Transfer,
                meta: {
                    permission: {
                        ehrFeature: 'isUseTransfer'
                    }
                }
            },
            {
                path: 'appointments/:id/ePharmacy/:actId',
                name: 'appointmentDB-epharmacy',
                component: ePharmacyClinical,
                meta: {
                    permission: {
                        ehrFeature: 'isUsepharmacyPatientNewCrop'
                    }
                }
            },
            {
                path: 'clinical/:id/special-precautions/:recordid',
                name: 'Clinical-special-precautions',
                component: EditSpecialPrecautions,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientSpecialPr'
                    }
                }
            },
            {
                path: 'patients/:id/special-precautions',
                name: 'patient-special-precautions',
                component: EditSpecialPrecautions,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientSpecialPr'
                    }
                }
            },
            {
                path: 'patients/:id/discharges',
                name: 'patient-discharges',
                component: PatientDischargesListing,
                meta: {
                    permission: {
                        ehrFeature: 'isUseDischarge'
                    }
                }
            },
            {
                path: 'patients/:id/discharge/:recordid',
                name: 'patient-discharge-edit',
                component: Discharge,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUseDischarge'
                    }
                }
            },
            {
                path: 'appointments/:id/special-precautions/:actId',
                name: 'appointmentDB-special-precautions',
                component: EditSpecialPrecautions,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientSpecialPr'
                    }
                }
            },
            {
                path: 'allergylist',
                name: 'allergyList',
                component: AllergySetupList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'allergy-setup/:id/edit',
                name: 'allergy-setup-details',
                component: AllergySetup,
                props: { editMode: true }
            },
            {
                path: 'allergy-setup/add',
                name: 'allergy-setup-add',
                component: AllergySetup,
                props: { editMode: false }
            },
            {
                path: 'admissionsrep',
                name: 'AdmissionsRep',
                component: AdmissionsViewRep
            },
            {
                path: 'clinical/:id/mars-alerts/:recordid',
                name: 'Clinical-mars-alerts',
                component: EditMarsAlert,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientMarsAlert'
                    }
                }
            },
            {
                path: 'patients/:id/mars-alerts',
                name: 'patient-mars-alerts',
                component: EditMarsAlert,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientMarsAlert'
                    }
                }
            },
            {
                path: 'appointments/:id/mars-alerts/:actId',
                name: 'appointmentDB-mars-alerts',
                component: EditMarsAlert,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientMarsAlert'
                    }
                }
            },
            {
                path: 'clinical/:id/patient-alerts/:recordid',
                name: 'Clinical-patient-alerts',
                component: PatientAlertList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAlerts'
                    }
                }
            },
            {
                path: 'patients/:id/alerts',
                name: 'patient-alerts',
                component: PatientAlertList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAlerts'
                    }
                }
            },
            {
                path: 'appointments/:id/patient-alerts/:actId',
                name: 'appointmentDB-alerts',
                component: PatientAlertList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAlerts'
                    }
                }
            },
            {
                path: 'clinical/:id/add-patient-alert/:recordid',
                name: 'Clinical-patient-alert-add',
                component: EditPatientAlert,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAlerts'
                    }
                }
            },
            {
                path: 'patients/:id/add-alert',
                name: 'patient-alert-add',
                component: EditPatientAlert,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAlerts'
                    }
                }
            },
            {
                path: 'appointments/:id/add-patient-alert/:actId',
                name: 'appointmentDB-alert-add',
                component: EditPatientAlert,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAlerts'
                    }
                }
            },
            {
                path: 'clinical/:id/edit-patient-alert/:recordid/code/:code',
                name: 'Clinical-patient-alert-edit',
                component: EditPatientAlert,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAlerts'
                    }
                }
            },
            {
                path: 'patients/:id/edit-alert/:code',
                name: 'patient-alert-edit',
                component: EditPatientAlert,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAlerts'
                    }
                }
            },
            {
                path: 'appointments/:id/edit-patient-alert/:actId/code/:code',
                name: 'appointmentDB-alert-edit',
                component: EditPatientAlert,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientAlerts'
                    }
                }
            },
            {
                path: 'patientmarsrep',
                name: 'PatientMarsRep',
                component: patientMarsRep,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'clinical/:id/activity/:recordid',
                name: 'Clinical-activities',
                component: PatientActivitiesList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientActivities'
                    }
                }
            },
            {
                path: 'clinical/:id/add-activity/:recordid',
                name: 'clinical-add-activity',
                props: { editMode: false },
                component: PatientActivity,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientActivities'
                    }
                }
            },
            {
                path: 'clinical/:id/edit-activity/:recordid/code/:code',
                name: 'clinical-edit-activity',
                props: { editMode: true },
                component: PatientActivity,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientActivities'
                    }
                }
            },
            {
                path: 'patients/:id/activities',
                name: 'patient-activities',
                component: PatientActivitiesList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientActivities'
                    }
                }
            },
            {
                path: 'patients/:id/add-activity',
                name: 'patient-add-activity',
                component: PatientActivity,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientActivities'
                    }
                }
            },
            {
                path: 'patients/:id/edit-activity/:code',
                name: 'patient-edit-activity',
                component: PatientActivity,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientActivities'
                    }
                }
            },
            {
                path: 'appointments/:id/activities/:actId',
                name: 'appointmentDB-activitiesList',
                component: PatientActivitiesList,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientActivities'
                    }
                }
            },
            {
                path: 'appointments/:id/activities/:actId/add',
                name: 'appointmentDB-activitiesAdd',
                props: { editMode: false },
                component: PatientActivity,
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientActivities'
                    }
                }
            },
            {
                path: 'appointments/:id/activities/:actId/:code/edit',
                name: 'appointmentDB-activitiesEdit',
                props: { editMode: true },
                component: PatientActivity
            },
            {
                path: 'tools/audit',
                name: 'auditListing',
                component: AuditListing,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'tools/audit-setting',
                name: 'auditSettingListing',
                component: AuditSettingListing
            },
            {
                path: 'customexports',
                name: 'customExportsList',
                component: CustomExportsList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'customexports/:id',
                name: 'customExports',
                component: CustomExports
            },
            {
                path: 'customreports',
                name: 'customReports',
                component: CustomReports,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'chargesheet',
                name: 'chargesheet',
                component: ChargeSheet,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'chargesheet-detail/:id/:recordid',
                name: 'chargesheetdetail',
                component: ChargeSheetDetail
            },
            {
                path: 'chargesheet-work/:id/:recordid',
                name: 'chargesheetwork',
                component: ChargeSheetWork
            },
            {
                path: 'medicationinbox',
                name: 'medicationinbox',
                component: MedicationInbox,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patientfacesheetrep',
                name: 'PatientFaceSheetViewRep',
                component: PatientFaceSheetViewRep
            },
            {
                path: 'patientfacesheetbyadmrep',
                name: 'PatientFaceSheetByAdmissionRep',
                component: PatientFaceSheetByAdmissionRep
            },
            {
                path: 'clinical/:id/orders/:recordid',
                name: 'Clinical-orders',
                component: OrdersList,
                meta: {
                    permission: {
                        ehrFeature: 'isPhysiciansOrder'
                    }
                }
            },
            {
                path: 'clinical/:id/order-add/:recordid',
                name: 'Clinical-orders-add',
                component: Orders,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isPhysiciansOrder'
                    }
                }
            },
            {
                path: 'clinical/:id/order-detail/:recordid/code/:recId',
                name: 'Clinical-orders-details',
                component: Orders,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isPhysiciansOrder'
                    }
                }
            },
            {
                path: 'appointments/:id/orders/:actId',
                name: 'appointmentDB-orders',
                component: OrdersList,
                meta: {
                    permission: {
                        ehrFeature: 'isPhysiciansOrder'
                    }
                }
            },
            {
                path: 'appointments/:id/order-add/:actId',
                name: 'appointmentDB-orders-add',
                component: Orders,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isPhysiciansOrder'
                    }
                }
            },
            {
                path: 'appointments/:id/order-detail/code/:recId/:actId',
                name: 'appointmentDB-orders-details',
                component: Orders,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isPhysiciansOrder'
                    }
                }
            },
            {
                path: 'drugorders',
                name: 'DrugOrdersInbox',
                component: DrugOrdersInbox,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'tars',
                name: 'tars-list',
                component: TarsList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'tars/:id',
                name: 'patient-tars',
                component: MarsPatientMed
            },
            {
                path: 'drugordersvalidation',
                name: 'DrugOrdersInboxValidation',
                component: DrugOrdersInboxValidation
            },
            {
                path: 'drugordersfill',
                name: 'DrugOrdersInboxFill',
                component: DrugOrdersInboxFill
            },
            {
                path: 'itemsreceived',
                name: 'ePharmacyItemsReceived',
                component: ePharmacyItemsReceivedList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'itemsreceived/add',
                name: 'ePharmacyItemsReceivedAdd',
                component: ePharmacyItemsReceived,
                props: { editMode: false },
                meta: {
                    permission: {
                        action: 'Add'
                        //ehrFeature: null
                    }
                }
            },
            {
                path: 'itemsreceived/edit/:recId',
                name: 'ePharmacyItemsReceivedEdit',
                component: ePharmacyItemsReceived,
                props: { editMode: true },
                meta: {
                    permission: {
                        action: 'Edit'
                        //ehrFeature: null
                    }
                }
            },
            {
                path: 'itemsrelocation',
                name: 'DrugOrderItemsRelocation',
                component: DrugOrderItemsRelocation,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'druginventoryitems',
                name: 'DrugInventoryItems',
                component: DrugInventoryItemsListing,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'druginventoryitems/add',
                name: 'drugInventoryItemsAdd',
                component: DrugInventoryItems,
                props: { editMode: false }
            },
            {
                path: 'druginventoryitems/edit/:recId',
                name: 'drugInventoryItemsEdit',
                component: DrugInventoryItems,
                props: { editMode: true }
            },
            {
                path: 'itemsremoval',
                name: 'DrugOrderItemsRemoval',
                component: DrugOrderItemsRemoval,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'pharmacyoptions',
                name: 'PharmacyOptions',
                component: PharmacyOptions,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'drugorders/returned-items',
                name: 'DrugOrdersReturnedItems',
                component: DrugOrderReturnedItems
            },
            {
                path: 'clinical/:id/letter/:recordid',
                name: 'Clinical-letters',
                component: PatientLettersList
            },
            {
                path: 'patients/:id/letters',
                name: 'patient-letters',
                component: PatientLettersList
            },
            {
                path: 'appointments/:id/letters/:actId',
                name: 'appointmentDB-letters',
                component: PatientLettersList
            },
            {
                path: 'patients/:id/letter-add',
                name: 'patient-letter-add',
                component: LetterManagement,
                props: { editMode: false }
            },
            {
                path: 'appointments/:id/letter-add/:actId',
                name: 'appointmentDB-letter-add',
                component: LetterManagement,
                props: { editMode: false }
            },
            {
                path: 'clinical/:id/letter-add/:recordid',
                name: 'Clinical-letter-add',
                component: LetterManagement,
                props: { editMode: false }
            },
            {
                path: 'patients/:id/letter-edit/:letterId',
                name: 'patient-letter-detail',
                component: LetterManagement,
                props: { editMode: true }
            },
            {
                path: 'appointments/:id/letter-edit/:letterId/:actId',
                name: 'appointmentDB-letter-detail',
                component: LetterManagement,
                props: { editMode: true }
            },
            {
                path: 'clinical/:id/letter-edit/:letterId/:recordid',
                name: 'Clinical-letter-detail',
                component: LetterManagement,
                props: { editMode: true }
            },
            {
                path: 'patients/:id/prescreening',
                name: 'prescreening',
                component: PreScreeningEditor
            },
            {
                path: 'testresult/pss',
                name: 'testresult',
                component: ClinicalTestResultPSS
            },
            {
                path: 'appointments/:id/testresult/pss/:actId',
                name: 'appointmentDB-testresult',
                component: ClinicalTestResultPSS
            },
            {
                path: 'vendorssetuplist',
                name: 'vendors',
                component: Vendorssetuplist,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'setupvendor/add',
                name: 'vendorAdd',
                component: Vendors,
                props: { editMode: false }
            },
            {
                path: 'setupvendor/edit/:recId',
                name: 'vendorEdit',
                component: Vendors,
                props: { editMode: true }
            },
            {
                path: 'drugsprotocolsetuplist',
                name: 'DrugsProtocolSetupList',
                component: DrugsProtocolSetupList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'drugsprotocolsetuplist/:id/edit/',
                name: 'DrugsProtocolSetup-Detail',
                component: DrugsProtocolSetupManagement,
                props: { editMode: true },
                meta: {
                    permission: {
                        action: 'Edit'
                    }
                }
            },
            {
                path: 'drugsprotocolsetuplist/add',
                name: 'DrugsProtocolSetup-Add',
                component: DrugsProtocolSetupManagement,
                props: { editMode: false },
                meta: {
                    permission: {
                        action: 'Add'
                    }
                }
            },
            {
                path: 'pharmacylocationssetuplist',
                name: 'PharmacyLocationsSetupList',
                component: PharmacyLocationsList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'pharmacylocationssetuplist/:id/edit/',
                name: 'PharmacyLocationsSetup-Detail',
                component: PharmacyLocations,
                props: { editMode: true }
            },
            {
                path: 'pharmacylocationssetuplist/add',
                name: 'PharmacyLocationsSetup-Add',
                component: PharmacyLocations,
                props: { editMode: false }
            },
            {
                path: 'itemscategorysetuplist',
                name: 'ItemcategoryListing',
                component: ItemCategoryListing,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'itemcategory/edit/:id',
                name: 'itemCategEdit',
                component: ItemCategory,
                props: { editMode: true }
            },
            {
                path: 'itemcategory/add',
                name: 'itemCategAdd',
                component: ItemCategory,
                props: { editMode: false }
            },
            {
                path: 'buildingpharmacylocationsetuplist',
                name: 'BuildingPharmacyLocationSetupList',
                component: BuildingPharmacyLocationSetupList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'buildingpharmacylocationsetuplist/:id/edit/',
                name: 'BuildingPharmacyLocationSetup-Detail',
                component: BuildingPharmacyLocationSetup,
                props: { editMode: true },
                meta: {
                    permission: {
                        action: 'Edit'
                    }
                }
            },
            {
                path: 'testcomponent',
                name: 'TestComponent',
                component: testcomponent
            },
            {
                path: 'unifiedprofile',
                name: 'unifiedprofile',
                component: UnifiedProfileList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'unifiedprofile/:id/edit',
                name: 'unifiedprofile-details',
                component: UserEmployeeDoctor,
                props: { editMode: true },
                meta: {
                    permission: {
                        action: 'Edit'
                    }
                }
            },
            {
                path: 'unifiedprofile/add',
                name: 'unifiedprofile-add',
                component: UserEmployeeDoctor,
                props: { editMode: false },
                meta: {
                    permission: {
                        action: 'Add'
                    }
                }
            },
            {
                path: 'daterangeattendance',
                name: 'date-range-attendance',
                component: DateRangeAttendanceList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'daterangeattendance/:id/edit',
                name: 'date-range-attendance-edit',
                component: DateRangeAttendance,
                props: { editMode: true },
                meta: {
                    permission: {
                        action: 'Edit'
                    }
                }
            },
            {
                path: 'editable-grid-demo',
                name: 'editable-grid-demo',
                component: EditableGridDemo
            },
            {
                path: 'clinical/:id/test-orders/:recordid',
                name: 'clinical-test-orders',
                component: TestOrderListing,
                meta: {
                    permission: {
                        ehrFeature: 'isTestOrders'
                    }
                }
            },
            {
                path: 'clinical/:id/test-order-add/:recordid',
                name: 'clinical-test-order-add',
                component: TestOrder,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isTestOrders'
                    }
                }
            },
            {
                path: 'clinical/:id/test-order-edit/:recordid/:recNo',
                name: 'clinical-test-order-edit',
                component: TestOrder,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isTestOrders'
                    }
                }
            },
            {
                path: 'appointments/:id/test-orders/:actId',
                name: 'appointments-test-orders',
                component: TestOrderListing,
                meta: {
                    permission: {
                        ehrFeature: 'isTestOrders'
                    }
                }
            },
            {
                path: 'appointments/:id/test-order-add/:actId',
                name: 'appointments-test-order-add',
                component: TestOrder,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isTestOrders'
                    }
                }
            },
            {
                path: 'appointments/:id/test-order-edit/:recNo/:actId',
                name: 'appointments-test-order-edit',
                component: TestOrder,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isTestOrders'
                    }
                }
            },
            {
                path: 'clinical/:id/test-order-result/:recordid/:recNo',
                name: 'clinical-test-order-result',
                component: TestOrderResult,
                meta: {
                    permission: {
                        ehrFeature: 'isTestOrders'
                    }
                }
            },
            {
                path: 'patientsportal',
                name: 'patients-portal',
                component: PatientsPortalDashboard,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patientsportal/patient-info/:id',
                name: 'patients-portal-info',
                component: PatientsPortalInfo,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patientsportal/patient-form',
                name: 'patients-portal-form',
                component: PatientsPortalForm,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patientsportal/message',
                name: 'patients-portal-message',
                component: PatientsPortalMessage,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patientsportal/patient-change-info/:id?',
                name: 'patients-portal-change-info',
                component: PatientsPortalChangeInfo,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patientsportal/patient-contacts/:id',
                name: 'patients-portal-contacts',
                component: PatientsPortalContactList,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patientsportal/patient-contacts/:id/add',
                name: 'patient-portal-contact-add',
                component: Contacts,
                props: { editMode: false },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'patientsportal/patient-contacts/:id/edit/:contactid',
                name: 'patient-portal-contact-edit',
                component: Contacts,
                props: { editMode: true },
                meta: {
                    permission: {
                        ehrFeature: 'isUsePatientContact'
                    }
                }
            },
            {
                path: 'patientsportal/patient-claims',
                name: 'patients-portal-claims',
                component: PatientsPortalClaims,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patientsportal/patient-summary/:id',
                name: 'patients-portal-summary',
                component: PatientsPortalSummary,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'patientportaloptions',
                name: 'patients-portal-setup',
                component: PatientsPortalSetup,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'lablocationssetuplist',
                name: 'TestOrderLocListing',
                component: TestOrderLocListing,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'testorderlocation/edit/:id',
                name: 'TestOrderLocEdit',
                component: TestOrderLocation,
                props: { editMode: true }
            },
            {
                path: 'testorderlocation/add',
                name: 'TestOrderLocAdd',
                component: TestOrderLocation,
                props: { editMode: false }
            },
            {
                path: 'testordersetuplist',
                name: 'TestOrdersResultSetupListing',
                component: TestOrdersResultSetupListing,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'testordersetup/edit/:id',
                name: 'TestOrderSetupEdit',
                component: TestOrdersResultSetup,
                props: { editMode: true }
            },
            {
                path: 'testordersetup/add',
                name: 'TestOrderSetupAdd',
                component: TestOrdersResultSetup,
                props: { editMode: false }
            },
            {
                path: 'patientcensusreport',
                name: 'PatientCensusReport',
                component: PatientCensusRep,
                props: { showModal: true }
            },
            {
                path: 'testpanelsetuplist',
                name: 'TestPanelSetupListing',
                component: TestPanelSetupListing,
                meta: {
                    permission: {
                        action: 'View'
                    }
                }
            },
            {
                path: 'testpanelsetup/edit/:id',
                name: 'TestPanelSetupEdit',
                component: TestPanelSetup,
                props: { editMode: true }
            },
            {
                path: 'testpanelsetup/add',
                name: 'TestPanelSetupAdd',
                component: TestPanelSetup,
                props: { editMode: false }
            }
        ]
    }
];

// eslint-disable-next-line no-new
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(/*to, from, savedPosition*/) {
        // We make sure the scroll is always on top
        return new Promise(resolve => {
            // Use Vue.nextTick to update the DOM
            Vue.nextTick(() => {
                const container = document.querySelector('.m-pagecontent');
                if (container) {
                    container.scrollTop = 0;
                }
                resolve({ x: 0, y: 0 });
            });
        });
    }
});

router.beforeEach((to, from, next) => {
    if (to.path === '/unauthorized') {
        return next();
    }
    const isPublic = to.matched.some(record => record.meta.public);
    const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);
    const loggedIn = UserService.IsLoged();
    const isAuthenticated = UserService.IsAuthenticated();
    const redirectToRestrictions =
        store.state.redirectToRestrictions &&
        ![
            '/',
            '/login',
            '/provider',
            'accessdenied',
            '/AccountExpired',
            '/unauthorized',
            '/forgotpassword',
            '/recoverypassword/'
        ].includes(to.path);

    // Route it not public and user is not Authenticated
    if (!isPublic && !loggedIn && to.path !== '/login') {
        return next('/login');
    }

    //User is loged but don´t have select provider
    if (loggedIn && !isAuthenticated && to.path !== '/provider') {
        return next('/provider');
    }

    // if onlyWhenLoggedOut and user it logged reroute to root
    if (loggedIn && onlyWhenLoggedOut && to.path !== '/') {
        return next('/');
    }

    if (redirectToRestrictions && to.path !== '/restrictions') {
        return next({ path: '/restrictions', replace: true });
    }

    const hasPermission = store.getters.hasPermission;
    const path = to.path;
    if (!hasPermission(path, to.meta?.permission) && to.path !== '/accessdenied') {
        return next({ path: '/accessdenied', replace: true });
    }

    next();
});

router.onError(error => {
    if (error.message.includes('Redirected')) {
        console.warn('Redirección controlada:', error.message);
    } else {
        console.error('Error de navegación:', error);
    }
});

export default router;
